import jwtAuthAxios from "services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getByIdMataKuliah = createAsyncThunk("rencanaEval/getByIdMataKuliah",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/rencana/evaluasi/matkul/ids/${val}`
            const response = await jwtAuthAxios.get(url)
            return response.data
        } catch (response) {
            throw response
        }
    });

export const addData = createAsyncThunk("rencanaEval/addData",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/rencana/evaluasi/matkul/adds`
            const response = await jwtAuthAxios.post(url, val)
            return response.data
        } catch (response) {
            throw response
        }
    });

export const udateRencanaEvaluasi = createAsyncThunk("rencanaEval/udateRencanaEvaluasi",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/rencana/evaluasi/matkul`
            const response = await jwtAuthAxios.put(url, val)
            return response.data
        } catch (response) {
            throw response
        }
    });

const initialState = {
    loadingByIdMataKuliah: false,
    loadingAdd: false,
    loadingUpdate: false,
    dataAdd: {},
    dataUpdate: {},
    dataMataKuliah: [],
}

const rencanaEvalSlice = createSlice({
    name: "rencanaEval",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getByIdMataKuliah.pending, (state) => {
                state.loadingByIdMataKuliah = true;
            })
            .addCase(getByIdMataKuliah.fulfilled, (state, action) => {
                state.dataMataKuliah = action.payload;
                state.loadingByIdMataKuliah = false;
            })
            .addCase(getByIdMataKuliah.rejected, (state, action) => {
                state.loadingByIdMataKuliah = false;
                console.error("Error during getMatkul:", action.error);
            })
        builder
            .addCase(addData.pending, (state) => {
                state.loadingAdd = true;
            })
            .addCase(addData.fulfilled, (state, action) => {
                state.dataAdd = action.payload;
                state.loadingAdd = false;
            })
            .addCase(addData.rejected, (state, action) => {
                state.loadingAdd = false;
                console.error("Error during getMatkul:", action.error);
            })
        builder
            .addCase(udateRencanaEvaluasi.pending, (state) => {
                state.loadingUpdate = true;
            })
            .addCase(udateRencanaEvaluasi.fulfilled, (state, action) => {
                state.dataUpdate = action.payload;
                state.loadingUpdate = false;
            })
            .addCase(udateRencanaEvaluasi.rejected, (state, action) => {
                state.loadingUpdate = false;
                console.error("Error during getMatkul:", action.error);
            })

            ;
    }
})
export const rencanaEvalSelectors = (state) => state.rencanaEval;
export default rencanaEvalSlice.reducer;